module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-spacing"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', [_vm._v("默认15px高")]), _vm._v(" "), _c('mt-layout-spacing', {
    attrs: {
      "border": "0.5px solid #52C7CA",
      "borderside": _vm.borderside
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', [_vm._v("自定义背景色")]), _vm._v(" "), _c('mt-layout-spacing', {
    attrs: {
      "background": "rgba(0,0,0,0.1)"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b589d61a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/layout-spacing.vue
// module id = 563
// module chunks = 0